
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonSupplement} from "@/models/app/common/supplement";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import {InfoFilled} from "@element-plus/icons-vue";
import AppPlayerResourcesRootSupplementsFormLookupVue from "@/views/app/player/resources/root/supplements/form/lookup.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    InfoFilled,
    AppPlayerResourcesRootSupplementsFormLookupVue,
  },
})
export default class AppPlayerResourcesRootSupplementsListIndexVue extends Vue {
  isLoading: boolean | null = false;

  supplements: Array<AppCommonSupplement> = [];

  async getSupplements(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/supplements`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.supplements = r.data.sort(function (a, b) {
          if (a.content.name < b.content.name) {
            return -1;
          }
          if (a.content.name > b.content.name) {
            return 1;
          }
          return 0;
        });
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getSupplements();
  }
}
